/**
 * Redux Store
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 03/03/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      03/03/2025    Akhil Soman     Creating new File
 */

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice.ts";
import globalReducer from "./globalSlice.ts";
import userReducer from "./userSlice.ts";

const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;

// Now your store is ready to handle both authentication and global state (loading & notifications)!
// Example usage:
// dispatch(setLoading(true));
// dispatch(addNotification({ id: '1', message: 'Task completed', type: 'success' }));
// dispatch(clearNotifications());
